




























































































































































































































































import { LsfParameters } from "@/common";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { AccountApi, IUser, IUserInfo } from "@/core/account";
import { RegistrationApi, IRegistration, ShirtSize, RegStatus } from "@/core/registration";
import RoomSelection from "@/components/RoomSelection.vue";

interface IRegistrationView {
	HasDog?: boolean;
	HasFursuit?: boolean;
	Arrival: string;
	Duration?: number;
	Room_ID?: number;
	RegistrationDate?: string;
	Intolerances?: string;
	ShirtAmount?: boolean;
	ShirtSize?: ShirtSize;
	Sponsor?: boolean;
	Status?: RegStatus;
	RegMailSent?: string;
	TotalCost?: number;
	AcceptRules: boolean;
	AcceptDogRules: boolean;
	AcceptGdpa: boolean;
	TotalDogCount?: number;
}

@Component({
	components: {
		RoomSelection,
	},
})

export default class Registration extends Vue {

	private get Rules(): { [name: string]: (v: any) => true | string } {
		return {
			RulesAccepted: v => v || this.$tc("reg_rule_rules"),
			DogAmount: v => !v || this.CurrentRegistration.HasDog || !this.Registration.TotalDogCount ||
				this.Registration.TotalDogCount < 3 || this.$tc("reg_rule_dog_limit"),
			Required: v => !!v || this.$tc("rule_required"),
		};
	}
	public get ShirtSizes(): string[] {
		return [
			ShirtSize.S,
			ShirtSize.M,
			ShirtSize.L,
			ShirtSize.XL,
			ShirtSize.XXL,
		];
	}
	public get CalcConfee(): number { return this.Fees.base; }
	public get CalcOvernight(): number {
		const stays = this.Registration.Duration;
		return stays ? this.Fees.overnight * stays : 0;
	}
	public get CalcDog(): number { return this.Registration.HasDog ? this.Fees.dog : 0; }
	public get CalcSponsor(): number { return this.Registration.Sponsor ? this.Fees.sponsor : 0; }
	public get CalcShirt(): number { return this.Registration.ShirtAmount ? this.Fees.shirt : 0; }

	public get CalcTotalCost(): number {
		return this.CalcConfee
			 + this.CalcOvernight
			 + this.CalcDog
			 + this.CalcSponsor
			 + this.CalcShirt;
	}
	public get IsLoaded(): boolean { return this.isLoaded; }
	public get IsNew(): boolean { return this.isNew; }
	public get IsAddable(): boolean { return Date.now() >= LsfParameters.RegAddStart; }
	public get IsEditable(): boolean { return Date.now() >= LsfParameters.RegEditStart; }
	public get IsShirtLocked(): boolean { return Date.now() >= LsfParameters.ShirtEditEnd; }
	public get IsSponsorLocked(): boolean { return Date.now() >= LsfParameters.SponsorEditEnd; }

	public get isFeeLocked(): boolean {
		return !this.Registration || this.Registration.Status !== RegStatus.New;
	}

	public get IsProfileComplete(): boolean { return this.isProfileComplete; }

	public AgeInYears: number = -1;
	public Snackbar: string | false = false;

	public Registration: IRegistrationView = {} as IRegistrationView;
	public CurrentRegistration: IRegistrationView = {} as IRegistrationView;

	public readonly ArrivalMin = "2024-06-29";
	public readonly ArrivalMax = "2024-07-06";

	public Birthdate: string = "";

	public readonly Fees = {
							base: 80,
							overnight: 40,
							sponsor: 30,
							shirt: 25,
							dog: 35,
	};
	public isSaving: boolean = false;
	public isDirty: boolean = false;

	private isNew: boolean = true;
	private isProfileComplete: boolean = false;
	private isLoaded: boolean = false;

	@Watch("Registration", { deep: true })
	public onRegistrationChanged(val: IRegistrationView, oldVal: IRegistrationView) {
		if (!val) return;
		this.isDirty = true;
		if (val.Arrival === this.ArrivalMax && val.Duration)
			val.Duration = 0;
	}

	public mounted() {
		this.LoadRegistrationData();
	}

	private async LoadRegistrationData() {
		const fnDateToIso = (d: Date) => {
			return `${d.getFullYear().toString().padStart(4, "0")}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
		};

		const api = new RegistrationApi();
		try {
			const reg = await api.load();
			this.isProfileComplete = reg.IsUserComplete === "1";

			if (reg.Status === undefined)
				throw new Error("New Registration");
			const s = `${reg.Status}`;
			this.Registration = {
				HasDog: reg.HasDog === "1",
				HasFursuit: reg.HasFursuit === "1",
				Arrival: fnDateToIso(new Date(+new Date(this.ArrivalMin) + (reg.Arrival * 1000 * 24 * 60 * 60 ))),
				Duration: reg.Duration,
				Room_ID: reg.Room_ID,
				RegistrationDate: reg.RegistrationDate,
				Intolerances: reg.Intolerances,
				ShirtAmount: reg.ShirtAmount === "1",
				ShirtSize: reg.ShirtSize,
				Sponsor: reg.Sponsor === "1",
				Status: (s === RegStatus.New || s === RegStatus.BillSent || s === RegStatus.Paid) ? s : RegStatus.New,
				RegMailSent: reg.RegMailSent,
				TotalCost: reg.TotalCost,
				AcceptRules: reg.AcceptRules === "1",
				AcceptDogRules: reg.AcceptRules === "1" && reg.HasDog === "1",
				AcceptGdpa: reg.AcceptGdpa === "1",
				TotalDogCount: reg.TotalDogCount,
			};
			this.isNew = false;
		} catch (e) {
			this.Registration = {
				Arrival: this.ArrivalMin,
				RegistrationDate: new Date().toISOString(),
				Status: RegStatus.New,
				Duration: 7,
				ShirtAmount: false,
				Room_ID: undefined,
				AcceptRules: false,
				AcceptDogRules: false,
				AcceptGdpa: false,
				TotalDogCount: 0,
			};
			this.isNew = true;
		}

		{
			this.CurrentRegistration = this.Registration;
			const accountApi = new AccountApi();
			const user = await accountApi.load();
			this.Birthdate = user.Birthdate;
			this.AgeInYears = (
					new Date( new Date(this.ArrivalMin).getTime() -
					new Date(this.Birthdate).getTime())
				.getUTCFullYear() - 1970);
		}

		this.isLoaded = true;

		setTimeout(() => {
			this.isDirty = false;
		});
	}
	private async UpdateRegistrationData() {
		if (!this.Registration.Duration)
			this.Registration.Room_ID = undefined;
		if (this.AgeInYears < 16) {
			this.Snackbar = this.$tc("reg_underage");
			return;
		}
		if (this.Registration.Duration && (this.Registration.Room_ID === null || this.Registration.Room_ID === undefined) ) {
			this.Snackbar = this.$tc("reg_rule_room");
			return;
		}
		if (!(this.$refs.form as any).validate()) {
			this.Snackbar = this.$tc("rule_general_validation");
			return;
		}
		this.isSaving = true;
		const api = new RegistrationApi();

		await api.update({
			HasDog: this.Registration.HasDog ? "1" : "0",
			HasFursuit: this.Registration.HasFursuit ? "1" : "0",
			Arrival: (+new Date(this.Registration.Arrival) - +new Date(this.ArrivalMin)) / 1000 / 24 / 60 / 60,
			Duration: this.Registration.Duration,
			Room_ID: this.Registration.Room_ID,
			Intolerances: this.Registration.Intolerances,
			ShirtAmount: this.Registration.ShirtAmount ? "1" : "0",
			ShirtSize: this.Registration.ShirtSize,
			Sponsor: this.Registration.Sponsor ? "1" : "0",
			Status: this.Registration.Status,
			RegMailSent: this.Registration.RegMailSent,
			TotalCost: this.Registration.TotalCost,
			AcceptRules: this.Registration.AcceptRules ? "1" : "0",
			AcceptGdpa: this.Registration.AcceptGdpa ? "1" : "0",
		});
		this.isDirty = false;
		this.isSaving = false;
		await this.LoadRegistrationData();
		this.Snackbar = this.$tc("saved");
	}

}
